import { mutationTypes, actionTypes, errorTypes } from '@/types';
import { logger } from '@/tools/logger';

export default store => {
	store.subscribe(async mutation => {
		if (mutation.type === mutationTypes.setIsApp) {
			window.nativeOnAREndSession = function(_result) {
				const result = _result ? _result : {};
				store.dispatch('pushUrl', { url: store.state.augmentedRealityPreviousPath });
				// Set the augmentedreality article to be null in the state
				store.commit(mutationTypes.augmentedRealitySetArticle, { article: null });

				if (typeof result !== 'object') {
					logger.error(
						`nativeOnAREndSession returned a ${typeof result}, it must return nothing or an object. This will result in an error in the future.`
					);
					return;
				}
				if ('PlayingMediaObjects' in result) {
					store.dispatch(
						actionTypes.audioLoadAndPlay,
						Object.assign(
							{
								mediaID: result.PlayingMediaObjects.id,
								position: result.PlayingMediaObjects.position,
								startPlaying: true,
							},
							result.PlayingMediaObjects.I18nContent[0]
						)
					);
				}
				store.commit(mutationTypes.augmentedRealitySetResult, result);
				if ('ActivatedVUMarkIDs' in result) {
					// List of all activated VUMARK ids [4,7,5,4,1] unordered with dups
				}
			};
			/**
			 * Method is called by native App to open an article wit articleID.
			 * Legacy use nativeOnContentCommand instead
			 * @param {String} articleID
			 */
			window.nativeOnContentOpenArticle = function(articleID) {
				store.dispatch(actionTypes.setArticle, { articleID, endTour: true });
				// store.commit(mutationTypes.augmentedRealitySetArticle, { article: null });
			};
			/**
			 * Method is called by native App to execute a webclient command.
			 * Command string sceme: command://method?param1=val1&param2=val2 ... | method2?...
			 * @param {String} command
			 */
			window.nativeOnContentCommand = function(command) {
				store.dispatch(actionTypes.parseCommands, { rawString: command, parseCommandTimer: true });
			};

			window.nativeOnContentLoadError = function(/* errorCode, failingUrl */) {
				store.dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.onNativeLoadError) });
			};

			/** If app looses Audio focus has to restart **/
			window.restartPlayer = function() {
				'use strict';
				// TODO Reimplemnt
			};
		}
	});
};
